import React, { useContext } from 'react';
import styled from 'styled-components';
import { UserContext } from '../../../contexts/UserContext';

const NoPatron = ({ message }) => {
  const { Site } = useContext(UserContext);
  const patronLabel = Site.siteType === 0 || Site.siteType === 5 ? 'student' : 'staff';

  return <Container>{message || `No ${patronLabel} selected`}</Container>;
};

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 4rem;
`;

export default NoPatron;
